// extracted by mini-css-extract-plugin
export var statItem = "_cj-1";
export var statsRow = "_cj-0";